<template>
  <dialog-v2
    :show="show"
    :card-classes="['pa-0']"
    :title-classes="['pa-0']"
    persistent
    width="80%"
    max-width="60%"
    @close="$emit('close')">
    <v-toolbar flat class="k-orange-linear" slot="title">
      <v-toolbar-title class="white--text pl-4 py-3">
        Plantillas de respuesta
      </v-toolbar-title>
    </v-toolbar>
    <div slot="content">
      <v-layout row wrap py-2>
        <v-flex xs12>
          <!-- <data-table-v3
            search-fields="name"
            :url="url"
            fields="name,text,channel"
            content="answerTemplatesList"
            :filters="filters"
            :search-on-create="false"
            :bus="bus"
            :limit="10" @close="dialog = false">
            <template slot="navigation-bar">
              <v-flex md9 pr-1>
                <v-text-field
                  v-model="filter.search"
                  label="Buscar..."
                  color="black"
                  class="elevation-0 grey-filter"
                  solo>
                </v-text-field>
              </v-flex>
              <v-flex md3 pl-1>
                <v-select
                  v-model="filter.category"
                  :items="categories"
                  color="grey"
                  class="elevation-0 grey-filter"
                  autocomplete
                  solo>
                </v-select>
              </v-flex>
            </template>
          </data-table-v3> -->
          <data-table-v3
            :items="templates"
            :meta="meta"
            :page="meta.current_page"
            @page="$store.commit('answerTemplates/UPDATE_PAGE', $event)">
            <template slot="navigation-bar">
              <v-flex md9 pr-1>
                <v-text-field
                  v-model="filter.search"
                  label="Buscar..."
                  color="black"
                  class="elevation-0 grey-filter"
                  solo>
                </v-text-field>
              </v-flex>
              <v-flex md3 pl-1>
                <v-select
                  v-model="filter.category"
                  :items="categories"
                  color="grey"
                  class="elevation-0 grey-filter"
                  autocomplete
                  solo>
                </v-select>
              </v-flex>
            </template>
            <answer-template-list
              class="mt-3"
              v-for="(item, i) in templates"
              :item="item"
              :key="`answerTemplate${i}`"
              @selected="$emit('selected', $event)">
            </answer-template-list>
          </data-table-v3>
        </v-flex>
      </v-layout>
    </div>
  </dialog-v2>
</template>

<script>
import { mapGetters } from 'vuex';
import EventBus from '@/event-bus';
import DialogV2 from '@/components/global/DialogV2';
import ChannelMixins from '@/mixins/channelsV2';
import DataTableV3 from '@/components/global/DataTableV3/DataTableV3';
import AnswerTemplateList from '@/components/answer_template/AnswerTemplatesListV2';
import { filter } from 'lodash';
// import DataTable from '@/components/global/DataTable';

export default {
  mixins: [ChannelMixins],
  components: {
    DialogV2,
    DataTableV3,
    AnswerTemplateList,
    // DataTable,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    channel: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    EventBus.$on('update', () => {
      this.$store.dispatch('answerTemplates/GET_TEMPLATES', {
        channel: this.channel,
        ...this.filters,
      });
    });
  },
  data() {
    return {
      refresh: false,
      limit: 10,
      filter: {
        search: '',
        category: '',
        status: 'activo',
      },
    };
  },
  computed: {
    ...mapGetters({
      categories: 'answerTemplates/categories',
      templates: 'answerTemplates/templates',
      meta: 'answerTemplates/meta',
    }),
    filters() {
      const channel = this.channel;
      return {
        ...this.filter,
        channel,
      };
    },
  },
  methods: {
    getTemplates() {
      this.$store.dispatch('answerTemplates/GET_TEMPLATES', {
        ...this.filters,
        page: this.meta.current_page,
        limit: this.limit,
        paginate: 2,
      });
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.getTemplates();
        this.$store.dispatch('answerTemplates/GET_CATEGORIES', this.filters);
      } else {
        const keys = Object.keys(this.filter);
        keys.forEach((item) => {
          this.filters[item] = '';
        });
        this.$store.commit('answerTemplates/SET_TEMPLATES', {
          items: [],
        });
        this.$store.commit('answerTemplates/SET_CATEGORIES', []);
      }
    },
    filter: {
      deep: true,
      handler() {
        this.getTemplates();
      },
    },
    'meta.current_page'() {
      this.getTemplates();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/chat_center_v2/AnswerTemplates.vue